import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Wrapper(props) {
  const className = `${style.modalWrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * children given to wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrapper.defaultProps = {
  className: '',
};
